// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__13nLE","filesListContainer":"PosDisputesFiles_filesListContainer__2FCa3","filesButton":"PosDisputesFiles_filesButton__10FaZ"};